import React, { useEffect, useState } from "react";
import classes from "./Pricelist.module.css";
import { ReactComponent as Cube } from "../../assets/squares-bg 4.svg";
import { ReactComponent as OrderBox } from "../../assets/order-box.svg";
import DefaultInput from "../../components/form/DefaultInput";
import { Button, Checkbox, Divider } from "antd";
import DefaultSelect from "../../components/form/DefaultSelect";
import { fetchZones, getConfigurationValue } from "../../lib/OptionListApi";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import StandardPackage from "./StandardPackage";

const Pricelist = () => {
	const [countryDropDown, setCountryDropDown] = useState<any>([]);
	const [cityDropDown, setCityDropDown] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);
	const [country, setCountry] = useState<string | number | undefined>();
	const [city, setCity] = useState<string | undefined>();

	const [width, setWidth] = useState(20);
	const [length, setLength] = useState(20);
	const [height, setHeight] = useState(20);
	const [weight, setWeight] = useState(0.5);
	const [packageSize, setPackageSize] = useState<any>("");
	const [price, setPrice] = useState<any>();
	const [orderPrice, setOrderPrice] = useState("");
	const [countryId, setCountryId] = useState<any>(null);

	const setCountriesAndCities = async () => {
		const zones = await fetchZones();
		if (zones) {
			const countries = zones
				.filter((item: any) => item.levelId === 1)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCountryDropDown(countries);
			const filteredCities = zones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCityDropDown(filteredCities);
			const cities = zones?.filter((item: any) => item.levelId === 2);
			setCities(cities);
		}
	};

	const fetchCountryId = async () => {
		try {
			const value = await getConfigurationValue(2);
			const countryId = Number(value);
			setCountryId(countryId);
		} catch (error) {
			console.error("Failed to fetch country ID:", error);
		}
	};

	useEffect(() => {
		setCountriesAndCities();
		fetchCountryId();
	}, []);

	const onCountrySelect = (countryId: any) => {
		setCountry(countryId);
		const filteredCities = cities
			.filter((item: any) => item.parentId === countryId)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setCity("");
	};

	const calculatePrice = async () => {
		if (!country) {
			toast.error("Ju lutem selektoni shtetin");
			return;
		}
		if (!orderPrice) {
			toast.error("Ju lutem plotesoni cmimin e porosise");
			return;
		}
		try {
			const response = await api.post(
				"Order/transport-price-calculator",
				{
					OrderPrice: parseFloat(orderPrice),
					Width: width,
					Length: length,
					Height: height,
					Weight: weight,
					ZoneId: country,
					SellerId: 1,
				}
			);

			setPrice(response?.data?.transportPrice);
		} catch (error: any) {
			console.log(error.response.data);
		}
	};

	return (
		<div className={classes.mainContainer}>
			<div className={classes.firstContainer}>
				<div className={classes.titles}>
					<div>
						<h1 className={classes.title}>Çmimi</h1>
						<p>Kosto e thjeshtuar e dërgesave tuaja!</p>
					</div>
				</div>
				<Cube />
			</div>
			<div className={classes.secondContainer}>
				{countryId === 2 && (
					<>
						<div className="flex flex-wrap gap-2">
							<StandardPackage
								title="Pako Standarte (Tiranë)"
								titlePrice="300 ALL"
								items={[
									"Dërgesë në Tiranë (vetëm qytet)",
									"Peshë  deri 2kg",
									"Përmasa: 20x20x20 cm",
								]}
							/>
							<StandardPackage
								title="Pako Standarte (Kombëtare)"
								titlePrice="360 ALL"
								items={[
									"Dërgesë në të gjithë Shqipërinë",
									"Peshë  deri 2kg",
									"Përmasa: 20x20x20 cm",
								]}
							/>
							<StandardPackage
								title="Pako Standarte Kosovë"
								titlePrice="6 €"
								items={[
									"Dërgesë në të gjithë Kosoven",
									"Peshë  deri 2kg",
									"Përmasa: 20x20x20 cm",
								]}
							/>
							<StandardPackage
								title="Pako Standarte Maqedoni e Veriut"
								titlePrice="8 €"
								items={[
									"Dërgesë në të gjithë  territorin e Maqedonise se Veriut",
									"Peshë  deri 2kg",
									"Përmasa: 20x20x20 cm",
								]}
							/>
						</div>
					</>
				)}
				<p className="font-criteria font-medium text-lg leading-9  text-purple-700">
					Kalkulimi i kostos
				</p>
				<p className="font-bold">
					Dërgesat/pakot tuaja vijnë në çdo formë dhe madhësi, prandaj
					ne kemi zhvilluar një mënyrë transparente dhe të saktë të
					kalkulimit të kostos së transportit për secilën pako.
				</p>
				<div className={classes.boxContainer}>
					<div className={classes.boxDiv}>
						<OrderBox className={classes.orderBox} />
						<div className={classes.firstInputsBox}>
							<DefaultInput
								label="a) gjerësia"
								className={classes.boxInputs}
								value={width}
								onChange={(e) => setWidth(e.target.value)}
							/>
							<DefaultInput
								label="b) gjatësia"
								className={classes.boxInputs}
								value={length}
								onChange={(e) => setLength(e.target.value)}
							/>
							<DefaultInput
								label="c) lartësia"
								className={classes.boxInputs}
								value={height}
								onChange={(e) => setHeight(e.target.value)}
							/>
						</div>
						<Divider type="vertical" className={classes.line} />
					</div>
					<div className={classes.selectsDiv}>
						<div className={classes.secondInputsBox}>
							<DefaultSelect
								label="Shteti"
								flexDirection="col"
								alignCenter="start"
								placeholder="Zgjedh"
								className={classes.selectBox}
								options={countryDropDown}
								value={country}
								onChange={onCountrySelect}
							/>

							<DefaultInput
								className={classes.selectBox}
								placeholder="Zgjedh"
								label="Cmimi i porosise"
								value={orderPrice}
								onChange={(e) => setOrderPrice(e.target.value)}
							/>
							<div>
								{price && (
									<DefaultInput
										className={classes.selectBox}
										placeholder="Zgjedh"
										label="Kosto"
										value={price}
									/>
								)}{" "}
							</div>
						</div>
						<div className={classes.secondInputsBox}>
							<DefaultInput
								label="Pesha e pakos"
								// flexDirection="col"
								// alignCenter="start"
								className={classes.selectBox}
								value={weight}
								onChange={(e) => setWeight(e.target.value)}
							/>
							<p>
								<Checkbox /> &nbsp; Është pako e thyeshme?
							</p>
						</div>
					</div>
				</div>
				<div className={classes.buttonCalculate}>
					<Button className={classes.button} onClick={calculatePrice}>
						Kalkulo
					</Button>
				</div>
			</div>
		</div>
	);
};

export default Pricelist;
